import React from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/home/HeroSection';
import StatsSection from '../components/home/StatsSection';
import PopularServices from '../components/home/PopularServices';
import Testimonials from '../components/home/Testimonials';
import HowItWorks from '../components/home/HowItWorks';

import partenaire1 from '../assets/images/partenaire1.jpg';
import partenaire2 from '../assets/images/partenaire2.jpg';
import partenaire3 from '../assets/images/partenaire3.jpg';

const partenaires = [
  { name: 'YAS Togo', logo: partenaire1 },
  { name: 'drysco.com', logo: partenaire2 },
  { name: 'IELAB', logo: partenaire3 },
];

const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <StatsSection />
      <PopularServices />
      <Testimonials />
      <HowItWorks />
      
      {/* Section Partenaires - Version stylisée */}
      <section className="py-20 bg-gradient-to-b from-[#111111] to-[#0a0a0a]">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-[#F97316]/10 px-4 py-2 rounded-full mb-6">
              <span className="text-[#F97316] text-xl font-medium">Nos partenaires</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
              Ensemble, <span className="text-[#F97316]">on va plus loin</span>
            </h2>
            
            <p className="text-[#AAAAAA] text-lg mb-12 max-w-2xl mx-auto">
              Des partenaires de confiance qui partagent notre vision et nous aident à vous offrir le meilleur service.
            </p>
            
            {/* Grille des logos partenaires */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2 }}
              className="relative"
            >
              {/* Effet de fondu sur les bords*/}
              <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-[#111111] to-transparent z-10 pointer-events-none" />
              <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-[#111111] to-transparent z-10 pointer-events-none" />
              
              {/* Grille responsive */}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-8 items-center">
                {partenaires.map((partenaire, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    whileHover={{ 
                      scale: 1.05,
                      transition: { duration: 0.2 }
                    }}
                    className="group"
                  >
                    <div className="bg-[#1a1a1a] rounded-xl p-4 border border-[#252525] 
                                  group-hover:border-[#F97316]/50 group-hover:bg-[#1f1f1f]
                                  transition-all duration-300">
                      <img 
                        src={partenaire.logo}
                        alt={partenaire.name}
                        className="w-full h-auto max-h-12 object-contain grayscale opacity-60 
                                   group-hover:grayscale-0 group-hover:opacity-100
                                   transition-all duration-300"
                      />
                    </div>
                  </motion.div>
                ))}
              </div>
            </motion.div>
            
            {/* Texte de confiance supplémentaire */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="mt-12 pt-8 border-t border-[#252525]"
            >
              <div className="flex flex-wrap justify-center gap-6 text-sm text-[#888888]">
                <div className="flex items-center gap-2">
                  <span className="text-[#F97316]">✓</span> 
                  <span>Des partenaires fiables</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[#F97316]">✓</span> 
                  <span>Présence nationale</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-[#F97316]">✓</span> 
                  <span>Certification qualité</span>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;